module.exports = __webpack_public_path__ + "img/other.5acd7b1f.png";